import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-mobile-redirect-author',
    template: '',
    standalone: false
})
export class MobileRedirectAuthorComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.router.navigate(['/author', id]);
    }
  }
}
